const S=(whatHappens,whyItMayHappen,whatTeamIsDoing,variationNote,nextSteps)=>({whatHappens,whyItMayHappen,whatTeamIsDoing,variationNote,nextSteps});
const N=(id,title,when,description)=>({id,title,...(description?{description}:{}),when});
export const zh={
paediatrics:{
preparing:S('儿童或青少年来医院前，团队可能会说明药物、饮食、到达时间和需要携带的物品。家属也可以提前告知沟通需要、感官需要、残障、焦虑或其他合理调整。','提前准备可以让就诊更安全、更可预期，也帮助团队调整沟通和支持方式。','团队会确认就诊原因，并确保合适的人员和设备可以使用。他们会计划如何调整信息和护理方式。这应符合儿童或青少年的年龄、发育阶段和个人需要。','不同就诊的准备并不相同。有些孩子不需要特别准备，有些可能需要禁食、调整药物、更多时间、更安静的空间或游戏治疗/游戏支持。',[
N('attend-as-planned','按计划来院','当准备说明清楚且就诊可以进行时'),
N('arrange-adjustments','安排额外支持或合理调整','如果儿童或青少年需要额外支持','可能包括沟通支持、更安静的等候方式、更多时间、感官调整或帮助准备某项操作。'),
N('clarify-instructions','来院前确认不清楚的说明','如果对药物、禁食、到达时间或可提供的支持不确定')
]),
'during-visit':S('就诊或住院期间，工作人员可能会提问、测量生命体征并检查儿童或青少年。根据就诊原因，可能需要验血、留置针、影像检查、药物或其他操作。','这些检查有助于了解问题、监测情况并决定下一步护理。','团队会在医疗护理、舒适度、沟通和家庭参与之间取得平衡。他们可能使用游戏、分散注意力、止痛或其他方法，让检查和操作更容易进行。应根据儿童或青少年的年龄和理解能力，尽可能让他们参与决定。','父母和照护者通常是儿童护理的重要伙伴。有些检查或操作需要同意，年龄较大的儿童和青少年也可能更直接参与决定。',[
N('continue-care','继续评估或治疗','如果仍需要监测、治疗、检查或专科评估'),
N('go-home','准备回家','当不再需要医院护理时'),
N('admit-or-transfer','继续住院或转往其他专科服务','如果需要住院护理或更专门的治疗')
]),
'going-home':S('回家前，团队应解释药物、随访、活动、护理说明，以及出现哪些变化时家属应尽快咨询。如果仍有结果未出，应说明如何以及何时通知。','清楚的信息可以帮助家属知道哪些情况可以在家处理，以及什么时候需要复查。','团队会确认儿童或青少年可以安全回家。他们会完成处方和随访安排。还会提供安全提示，说明哪些症状或担忧不应等到常规预约再处理。','有些儿童不需要进一步医院随访，有些需要。请确认主要联系人是谁，以及病情加重时应该怎么做。',[
N('recover-at-home','在家继续护理或恢复','如果孩子正在好转，家庭计划按预期进行'),
N('planned-follow-up','参加计划中的随访','如果团队需要复查恢复、结果或治疗'),
N('earlier-help','如果出现担忧，提前寻求帮助','如果症状加重、出现新问题或孩子明显更不舒服','请使用团队提供的联系方式和安全提示。')
])},
renal:{
assessment:S('肾脏评估通常包括血压、血液检查和尿液检查。您可能会听到肌酐和eGFR，这些指标帮助团队了解肾功能。','肾脏负责从血液中清除废物和多余水分。检查有助于了解肾脏工作情况、变化是新出现还是长期存在，以及可能的原因。','团队会比较不同时期的结果，评估液体平衡、血压以及可能影响肾功能的药物。','单次结果不一定能说明全部情况。疾病、脱水或补液、药物和其他情况都可能影响肾功能。',[
N('monitor-kidney-function','继续监测肾功能','如果在改变治疗前需要重复检查'),
N('treatment-plan','开始或调整肾脏治疗计划','当原因和严重程度已经足够明确时'),
N('more-investigation','进行更多检查或专科评估','如果最初检查不能完全解释肾脏问题')
]),
treatment:S('治疗取决于原因和严重程度。可能包括调整药物、治疗其他疾病、控制血压、调整液体或饮食以及更密切监测。对于部分严重肾衰竭患者，团队可能会讨论透析。','治疗目的是保护剩余肾功能，并处理肾功能下降带来的问题。','团队会复查结果、药物、液体平衡、血压和症状。如果可能需要透析，应解释不同选择和准备工作。','并不是所有肾功能下降的人都需要透析。除非您的肾脏团队建议，否则不要自行限制食物、液体或药物。',[
N('continue-conservative-treatment','继续药物、监测和保护肾脏的措施','如果可以不用透析管理肾功能'),
N('dialysis-planning','讨论或准备透析','如果肾功能明显下降且可能需要透析','团队可能会讨论血液透析、腹膜透析或其他方式。'),
N('hospital-treatment','因急性肾脏问题接受医院治疗','如果肾功能快速恶化或出现并发症')
]),
'ongoing-care':S('长期肾脏护理可能包括定期血液和尿液检查、血压、药物复查，以及在需要时提供饮食或液体建议。','肾功能可能随时间变化，治疗也可能需要调整。','团队会持续观察肾功能，减少可避免的风险，治疗并发症，并说明什么时候应提前联系。','复诊频率取决于肾脏问题的原因和稳定程度。有些人需要长期专科随访，有些人检查可以更少。',[
N('specialist-follow-up','继续肾脏专科随访','如果仍需要专科监测、调整治疗或透析护理'),
N('shared-care','与基层医疗或其他服务继续共同管理','如果肾脏情况足够稳定'),
N('earlier-review','如果身体不适，提前联系肾脏团队','如果症状、液体平衡、尿量或其他问题发生变化')
])},
'mental-health':{
assessment:S('心理健康评估是一场关于近期发生了什么以及您感受如何的谈话。团队可能会询问您的身体健康、用药、睡眠、日常生活以及周围的支持情况。他们也可能直接询问您的安全情况。这可能包括您是否觉得自己有伤害自己或他人的风险。','评估有助于了解您正在经历什么、支持有多紧急，以及哪种帮助可能最合适。','团队会倾听您的经历，考虑您的优势和困难，检查当前安全情况，并与您一起计划下一步。','没有一种单一检查可以解释所有心理健康问题。评估可以在门诊、急诊、住院病房、社区服务中进行，也可以通过电话或视频进行。如果您觉得自己正处于直接危险中，或无法保证自己或他人的安全，请使用当地服务提供的紧急联系方式或急救服务。不要等待常规预约。',[
N('routine-support','进入计划中的支持或治疗','如果可以通过常规门诊或社区方式提供护理'),
N('more-assessment','接受进一步评估','如果需要更多信息或其他专科意见'),
N('urgent-support','接受更紧急或更密集的支持','如果存在重要或立即的安全担忧')
]),
support:S('支持可能包括谈话治疗、药物、实际或社会帮助、作业治疗、同伴支持，或几种方式结合。','不同问题和生活情况需要不同类型的支持。','团队会与您一起确定重点、协调参与人员，并评估支持是否有效。','并不是每个人都需要药物、治疗或相同强度的支持。计划可以根据您的需要和偏好调整。',[
N('continue-plan','继续已商定的护理计划','如果支持有效且当前复查强度合适'),
N('adjust-support','调整治疗或支持','如果症状、副作用或需要使其他方式更合适'),
N('step-up-support','增加支持强度','如果心理健康或安全状况恶化，需要更频繁或更紧急的护理')
]),
'next-steps':S('持续护理可能包括计划复诊、心理治疗、药物复查或社区支持。您也可能有一份危机计划，说明如果心理健康明显恶化应联系谁。有些人会有指定的护理协调员或其他主要联系人。这个人可以帮助不同部分的护理协同工作。','清楚的随访和危机计划可以帮助您知道有哪些支持，以及情况变差时该怎么做。','团队会复查进展，确认护理计划是否仍符合需要，并明确责任和联系方式。','有些人需要长期专科心理健康护理，有些人在稳定后转回基层医疗或其他社区服务。如果存在立即危险，请使用紧急渠道，不要等待计划中的随访。',[
N('continue-specialist-care','继续专科心理健康随访','如果仍需要专科治疗、监测或协调'),
N('step-down-care','转为较低强度或基层医疗随访','如果您的需要已经稳定'),
N('urgent-reassessment','如果安全或心理健康恶化，申请紧急重新评估','如果出现明显恶化或现有计划已不足够')
])}
};